import PropTypes from 'prop-types';
import React from 'react';
import _ from 'lodash';
import {connect as connectR} from 'react-redux';
import {Button, Col, FormControl, Row} from 'react-bootstrap';
import LargeCard from '../main/large-card';
import ValidatorFormGroup from '../main/validator-form-group';
import translate from '../translate';
import {ForceSetNewPassword, VerifyResetToken,} from '../../store/passwordResetSlice';
import {REQUEST_FAILURE, REQUEST_INITIAL, REQUEST_PENDING, REQUEST_SUCCESS,} from '../../store/network/managedRequest';
import withLocation from "../../nav/withLocation";

const VALIDATORS = {
    password: {
        isValid(val) {
            if (!val) {
                return false;
            }
            const atLeastOneDigit = /\d/.test(val);
            const atLeastOneLetter = /[a-zA-Z]/.test(val);
            const atLeastOneSpecial = /[\W_]/.test(val);
            return (
                val.length > 7 &&
                atLeastOneDigit &&
                atLeastOneLetter &&
                atLeastOneSpecial
            );
        },
    },
    passwordConfirm: {
        isValid(val, origPass) {
            return !!val && val === origPass;
        },
    },
    confirmCode: {
        isValid(val) {
            return !!val;
        },
    },
};

class PasswordResetForm extends React.Component {
    static propTypes = {
        resetTokenValidation: PropTypes.string.isRequired,
        forceSetNewPasswordRequest: PropTypes.shape({
            status: PropTypes.string,
        }).isRequired,
        strings: PropTypes.object,
        VerifyResetToken: PropTypes.func.isRequired,
        ForceSetNewPassword: PropTypes.func.isRequired,
        query: PropTypes.object.isRequired,
    };

    state = {
        submitted: false,
        data: {
            password: '',
            passwordConfirm: '',
            confirmCode: '',
        },
        _dirty: {},
        _valid: true,
    };

    componentWillMount() {
        const confirmCode = window.atob(this.props.query.get('key'));
        this.props.VerifyResetToken(confirmCode);
        const newState = _.extend({}, this.state, {
            data: _.extend({}, this.state.data, { confirmCode }),
        });
        this.setState(newState);
    }

    _markDirty = (key) => {
        const newDirt = {};
        newDirt[key] = true;
        const newState = _.extend({}, this.state, {
            _dirty: _.extend({}, this.state._dirty, newDirt),
        });
        this.setState(newState);
    };

    _isDataValid = (data) => {
        return Object.keys(VALIDATORS).reduce(
            (sum, fieldName) =>
                sum &&
                ((fieldName === 'passwordConfirm' &&
                    VALIDATORS.passwordConfirm.isValid(
                        data.passwordConfirm,
                        data.password
                    )) ||
                    VALIDATORS[fieldName].isValid(data[fieldName])),
            true
        );
    };

    _persist = (field, value) => {
        this._markDirty(field);
        const data = _.extend({}, this.state.data);
        data[field] = value;
        this.setState({ data, isValid: this._isDataValid(data) });
    };

    _handleSubmit = (event) => {
        console.log('submit');
        event.preventDefault();
        if (this.state.isValid) {
            this.props.ForceSetNewPassword(this.state.data);
            this.setState({ submitted: true });
        }
    };

    _loadDescription = () => {
        const resetTokenInvalid = [REQUEST_FAILURE].includes(
            this.props.resetTokenValidation
        );
        const passwordResetSuccessful = [REQUEST_SUCCESS].includes(
            this.props.forceSetNewPasswordRequest.status
        );
        if (resetTokenInvalid) {
            return this.props.strings.badKey;
        } else if (this.state.submitted && passwordResetSuccessful) {
            return this.props.strings.success;
        }
        return this.props.strings.resetMessage;
    };

    render() {
        const waitingOnVerify = [REQUEST_INITIAL, REQUEST_PENDING].includes(
            this.props.resetTokenValidation
        );
        if (waitingOnVerify) {
            return null;
        }
        const verified = [REQUEST_SUCCESS].includes(
            this.props.resetTokenValidation
        );
        const passwordResetSuccessful = [REQUEST_SUCCESS].includes(
            this.props.forceSetNewPasswordRequest.status
        );
        const passwordResetFailed = [REQUEST_FAILURE].includes(
            this.props.forceSetNewPasswordRequest.status
        );

        let form;
        if (verified && !passwordResetSuccessful) {
            form = (
                <form onSubmit={this._handleSubmit}>
                    <div className="wrap">
                        <ValidatorFormGroup
                            label={this.props.strings.password}
                            hideErrorLabel={
                                !this.state._dirty.password ||
                                VALIDATORS.password.isValid(
                                    this.state.data.password
                                )
                            }
                            helpLabel={this.props.strings.passwordHelp}
                            errorLabel={this.props.strings.passwordError}
                        >
                            <FormControl
                                type="password"
                                className={`input-text-color`}
                                value={this.state.data.password}
                                name="password"
                                onChange={(event) => {
                                    this._persist(
                                        'password',
                                        event.target.value
                                    );
                                }}
                                required
                            />
                        </ValidatorFormGroup>

                        <ValidatorFormGroup
                            label={this.props.strings.passwordConfirm}
                            hideErrorLabel={
                                !this.state._dirty.passwordConfirm ||
                                VALIDATORS.passwordConfirm.isValid(
                                    this.state.data.passwordConfirm,
                                    this.state.data.password
                                )
                            }
                            errorLabel={this.props.strings.passwordConfirmError}
                        >
                            <FormControl
                                type="password"
                                className={`input-text-color`}
                                value={this.state.data.passwordConfirm}
                                name="passwordConfirm"
                                onChange={(event) => {
                                    this._persist(
                                        'passwordConfirm',
                                        event.target.value
                                    );
                                }}
                                required
                            />
                        </ValidatorFormGroup>
                        {passwordResetFailed && (
                            <div className="alert alert-danger">
                                {this.props.strings.passwordError}
                            </div>
                        )}
                        <div className="form-footer">
                            <Row>
                                <Col xs={6}>
                                    <Button
                                        className="btn-primary btn btn-default"
                                        type="submit"
                                        disabled={!this.state.isValid}
                                    >
                                        {this.props.strings.submit}
                                    </Button>
                                </Col>
                            </Row>
                        </div>
                    </div>
                </form>
            );
        }
        return (
            <Col xs={6}>
                <LargeCard
                    title={this.props.strings.title}
                    type="card-edit"
                    description={this._loadDescription()}
                >
                    {form}
                </LargeCard>
            </Col>
        );
    }
}

export default connectR(
    (store) => ({
        resetTokenValidation: store.passwordReset.resetTokenValidation,
        forceSetNewPasswordRequest:
            store.passwordReset.forceSetNewPasswordRequest,
    }),
    { VerifyResetToken, ForceSetNewPassword }
)(translate('PasswordResetForm')(withLocation(PasswordResetForm)));
